import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { fileToBase64Link } from "Utils";
import ExtraDeduction from "./ExtraDeduction";
import ExtraPayments from "./ExtraPayments";
import Home from "./Home";
import LOPandArrears from "./LOPandArrears";
import Manualtax from "./Manualtax";
import LeaveEncashment from "./LeaveEncashment";
import GratuityPayments from "./GratuityPayments";

const styles = () => ({});

class SalaryAdjustments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salaryadjustpage: "home", // home, LOP, extrapayments, extradeduction,
      postData: null,
    };
    this.setsalaryadjustpage = this.setsalaryadjustpage.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.onDeleteDoc = this.onDeleteDoc.bind(this);
  }

  setsalaryadjustpage(page) {
    this.setState({ salaryadjustpage: page });
  }

  componentDidMount() {}

  onDeleteDoc(key) {
    const { postData } = this.state;
    postData[key] = null;
    this.setState({
      postData,
    });
  }

  async uploadDoc(key, files) {
    const file = files[0];
    const { postData } = this.state;
    const x = await fileToBase64Link(file);
    postData[key] = x;
    this.setState({
      postData,
    });
  }

  render() {
    const { salaryadjustpage = "LOP" } = this.state;

    return (
      <div>
        {salaryadjustpage === "home" && (
          <Home
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "LOP" && (
          <LOPandArrears
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "extrapayments" && (
          <ExtraPayments
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "extradeduction" && (
          <ExtraDeduction
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "manualtax" && (
          <Manualtax
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "leaveencashment" && (
          <LeaveEncashment
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
        {salaryadjustpage === "gratuitypayments" && (
          <GratuityPayments
            {...this.props}
            {...this.state}
            setsalaryadjustpage={this.setsalaryadjustpage}
          />
        )}
      </div>
    );
  }
}

export default connect()(
  withStyles(styles, { withTheme: true })(withSnackbar(SalaryAdjustments)),
);
